import { mutateEntity, mutateNestedEntity } from 'Root/store/components/commonMutations';
import OnlineDriver from 'Root/drivers/OnlineDriver';
import AppModel from 'Models/AppModel';
import MutationType from 'Models/MutationTypeModel';
import { MS_PER_MINUTE } from 'Root/helpers/DateConstants';

const driver = new OnlineDriver(
  `${AppModel.API_URI}/user/online_stats`,
);

let interval = null;

export default {
  state() {
    return {
      state: {},
      interval: null,
      lastFetchAt: null,
    };
  },

  mutations: {
    mutateEntity,
    mutateNestedEntity,
  },

  actions: {
    /**
     * начинаем следить за сущностью
     *
     * @param context
     * @param id
     */
    track(context, id) {
      if (!id) {
        return;
      }

      driver.track(id);
    },

    /**
     * перестаем следить за сущностью и удаляем из стейта
     *
     * @param commit
     * @param id
     */
    unTrack({ commit }, id) {
      if (!id) {
        return;
      }

      driver.unTrack(id);

      // выкидываем сущность из онлайн-стейта
      commit('mutateEntity', {
        entity: 'state',
        type: MutationType.DELETE_KEY,
        data: id,
      });
    },

    /**
     * запускаем интервал слежения за онлайном
     * если вкладка неактивна - ликвидируется
     *
     * @param state
     * @param rootState
     * @param dispatch
     */
    startTrackingInterval({ state, rootState, dispatch }) {
      // если последний запрос был больше минуты назад - бабахаем запрос сразу
      if (rootState.tabManager.isActiveTab() && state.lastFetchAt) {
        if (Date.now() - state.lastFetchAt > MS_PER_MINUTE) {
          dispatch('fetchStats');
        }
      }

      if (typeof window !== 'undefined' && !interval) {
        interval = setInterval(() => {
          // если таймер почему-то не очищен не долбимся с неактивных вкладок, смысла нет
          if (!rootState.tabManager.isActiveTab()) {
            dispatch('stopTrackingInterval');
            return;
          }

          dispatch('fetchStats');
        }, 30000);
      }
    },

    /**
     * стопает интевал слежения за онлайном
     */
    stopTrackingInterval() {
      if (!interval) {
        return;
      }

      clearInterval(interval);
      interval = null;
    },

    /**
     * дёргает онлайн данные из драйвера и обновляет онлайн стейт
     *
     * @param commit
     */
    fetchStats({ commit }) {
      driver.fetchStats()
        .then((data) => {
          commit('mutateEntity', {
            entity: 'lastFetchAt',
            data: Date.now(),
          });

          commit('mutateEntity', {
            entity: 'state',
            data,
          });
        });
    },
  },

  namespaced: true,
};
